const pomloApp = {};

// Define constants
pomloApp.BREAKPOINTS = {
  SM: 576,
  MD: 768,
  LG: 992,
  XL: 1140,
};
pomloApp.DEFAULT_DURATION = 300;
pomloApp.HEADER_BACKGROUND_HEIGHT = 50;
pomloApp.HEADER_HEIGHT = 115;

pomloApp.scrollTo = (selector) => {
  jQuery(selector).animatescroll({
    scrollSpeed: 600,
    padding: pomloApp.HEADER_HEIGHT,
    easing: 'easeInOutQuad',
  });
};

pomloApp.toggleHeaderStyle = () => {
  function setSmallHeader() {
    jQuery('body').addClass('header--small');
    jQuery('#navbar-container').addClass('navbar--small');
  }

  function unsetSmallHeader() {
    jQuery('body').removeClass('header--small');
    jQuery('#navbar-container').removeClass('navbar--small');
  }

  if ((jQuery(window).width() < pomloApp.BREAKPOINTS.MD) || (jQuery(window).scrollTop() > pomloApp.HEADER_HEIGHT)) {
    setSmallHeader();
  } else {
    unsetSmallHeader();
  }

  if ((jQuery(window).scrollTop() > pomloApp.HEADER_BACKGROUND_HEIGHT)) {
    jQuery('header').addClass('header--bg-1');
  } else {
    jQuery('header').removeClass('header--bg-1');
  }
};

jQuery(document).ready(() => {
  pomloApp.toggleHeaderStyle();

  jQuery('#current-year').text(new Date().getFullYear());

  // Init interface
  jQuery('#navbar__toggler--open, #navbar__toggler--close').click(() => {
    jQuery('#navbar__mobile').toggleClass('active');
    if (jQuery('#navbar__mobile').hasClass('active')) {
      jQuery('body').addClass('overflow-hidden');
    } else {
      jQuery('body').removeClass('overflow-hidden');
    }
  });

  jQuery('.scroll-to').click((event) => {
    event.preventDefault();
    const scrollLink = jQuery(event.target).data('target');
    pomloApp.scrollTo(scrollLink);
    if (jQuery('#navbar__mobile').hasClass('active')) {
      jQuery('#navbar__mobile').removeClass('active');
      jQuery('body').removeClass('overflow-hidden');
    }
  });

  jQuery('#services-menu__toggler').hover(() => {
    jQuery('#services-menu').stop(true, true).slideDown('fast');
  }, () => {
    jQuery('#services-menu').stop(true, true).slideUp('fast');
  });

  $('.services__toggler').on('click', function onClick() {
    jQuery('.reference-tab').addClass('hidden');
    jQuery(jQuery(this).data('target')).removeClass('hidden');
    jQuery('.timeline-item').removeClass((index, className) => {
      return className
        .split(' ')
        .filter((c) => c.startsWith('color-bg--') && c !== 'color-bg--1' && c !== 'color-bg--g')
        .join(' ');
    });
    jQuery(this).parent().addClass(`color-bg--${jQuery(this).data('color')}`);
  });

  if ($('.services__toggler').length > 0) {
    $('.services__toggler').first().trigger('click');
  }

  // eslint-disable-next-line no-undef
  pomloUIBlock.setBlockHeight('#skill');

  if (jQuery('#citations-splide').length) {
    // eslint-disable-next-line no-undef
    new Splide('#citations-splide', {
      type: 'fade',
      pagination: false,
      arrows: true,
      rewind: true,
      autoplay: false,
    }).mount();
  }

  /* FORMS : Contact and recruitment forms now using Yuzlo
  TAC is in manual mode for async hCaptcha script
  Yuzlo's hCaptcha site key is set on TAC for the two hCaptcha services created
   */
  jQuery('#form-contact, #form-recruitment').on('submit', async function submitContactForm(e) {
    e.preventDefault();
    const form = this;
    const notification = $(this).find('.form-notification');

    try {
      const response = await fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
      });

      if (!response.ok) throw new Error('Submission failed');

      form.reset();
      notification.text('Votre demande a bien été envoyée, nous vous contacterons dans les plus brefs délais.');
      notification.prop('hidden', false);
    } catch {
      notification.text('Une erreur est survenue, veuillez réessayer.');
      notification.prop('hidden', false);
    }
  });
});

jQuery(window).scroll(() => {
  pomloApp.toggleHeaderStyle();
});

jQuery(window).resize(() => {
  if (jQuery(window).width() >= pomloApp.BREAKPOINTS.LG) {
    jQuery('#navbar__mobile').removeClass('active');
  }
  pomloApp.toggleHeaderStyle();
  // eslint-disable-next-line no-undef
  pomloUIBlock.setBlockHeight('#skill');
});
